import axios from "axios"

let productListOverviewCache = null

const wc_weight_units = {
  kg: 1000,
  g: 1,
  lbs: 453.592,
  oz: 28.3495
}

async function updateProductListOverview() {
  if (productListOverviewCache === null) {
    const response = await axios.get(`${frontendLocalizer.apiUrl}/pingvin_checkout/v1/getProductListOverview`)
    if (response.data) {
      productListOverviewCache = JSON.parse(response.data)
    }
  }

  return productListOverviewCache
}

export async function getProductListOverview() {
  const res = await updateProductListOverview()
  const products = res[0]
  const categories = res[1]
  const currency = res[2]

  let productsByCategory = {}
  categories.map(category => {
    productsByCategory[category.name] = []
  })

  products.map(p => {
    let productToDo = p
    productToDo.unit = p._einheit
    productToDo.lot = p._gebinde
    productsByCategory[p.category_name.replace(/\//g, "-")].push(productToDo)
  })

  // Remove categories with no products
  const filteredCategories = categories.filter(category => productsByCategory[category.name].length > 0)

  return {
    products: products,
    categories: filteredCategories,
    currency: currency,
    productsByCategory: productsByCategory
  }
}

export async function getProductBySku(sku) {
  const res = await updateProductListOverview()
  let product = res[0].find(product => product.sku == sku)

  return product
}

export async function getProduct(id) {
  const res = await updateProductListOverview()
  let product = res[0].find(product => product.id == id)

  const currency = res[2]
  return { product, currency }
}

export async function getStockManagement() {
  const response = await axios.get(`${frontendLocalizer.apiUrl}/pingvin_checkout/v1/getOption?option=woocommerce_manage_stock`)
  if (response.data) {
    return response.data === '"yes"'
  } else {
    return false
  }
}

export async function getSelfCheckoutProducts() {
  const res = await updateProductListOverview()
  const products = res[0]

  // Return IDs of all products that have a SKU
  return products.filter(p => p.sku && p.sku.length > 0).map(p => p.id)
}

export function updateProductAmount(product, w, t) {
  if (product.is_weighed) {
    const prodWeightInG = product.weight * wc_weight_units[product.weight_unit]

    product.userWeightValue = formatProductWeight(w)
    product.userTaraValue = formatProductWeight(t)
    product.amountWeight = w > t ? formatProductWeight(w - t) : 0

    product.amount = w > t ? formatProductWeight(((w - t) / prodWeightInG) * 1000) : 0
  } else {
    product.userWeightValue = null
    product.userTaraValue = null
  }
}

export function formatProductWeight(w) {
  w = parseFloat(w)

  return Math.round(w * 1000) / 1000
}

// export async function addUserEinkaufsliste(cart, id) {
//   const produkte = cart.map(item => ({
//     sku: item.sku,
//     amount: item.amount,
//     weight: item.userWeightValue,
//     tara: item.userTaraValue
//   }))
//
//   const auto = !id
//   if (auto) id = self.crypto.randomUUID()
//
//   const response = await axios.post(
//     `${frontendLocalizer.apiUrl}/pingvin_checkout/v1/addUserEinkaufsliste`,
//     {
//       id: id,
//       auto: auto ? true : false,
//       date: Date.now(),
//       produkte: produkte
//     },
//     { headers: { "X-WP-Nonce": frontendLocalizer.nonce } }
//   )
//
//   return response
// }
